import { TField } from 'interfaces/authentication';

export const RegFieldsDefaultsJson = [
  {
    type: 'text',
    formType: 'username',
    editForm: {
      showOnRegFields: '1',
      required: '1',
      showOnEditProfile: '1',
      usernameInMyProfile: '1'
    }
  },
  {
    type: 'text',
    formType: 'address',
    editForm: {
      showOnRegFields: '1',
      required: '1',
      showOnEditProfile: '1'
    }
  },
  {
    type: 'text',
    formType: 'province',
    editForm: {
      showOnRegFields: '1',
      required: '1',
      showOnEditProfile: '1'
    }
  },
  {
    type: 'text',
    formType: 'city',
    editForm: {
      showOnRegFields: '1',
      required: '1',
      showOnEditProfile: '1'
    }
  },
  {
    label: 'Account Number',
    type: 'accountNumber',
    formType: 'accountNumber',
    name: 'iban',
    hasSettings: true,
    hidden: true,
    editForm: {
      label: 'Account Number',
      showOnRegFields: '1',
      showOnEditProfile: '1',
      required: '0',
      disabled: '0',
      customValidation: '0',
      customValidationCode: '',
      uploadDoc: '0',
      showAccountNumberPrefix: '1',
      accountNumberPrefix: 'FR'
    },
    params: {
      validations: {
        required: true
      }
    }
  },
  {
    type: 'radio',
    formType: 'gender',
    editForm: {
      showOnRegFields: '0',
      showOnEditProfile: '1',
      required: '1',
      disabled: '1'
    },
    params: {
      btnInfo: {
        male: 'M',
        female: 'F'
      },
      validations: {
        required: true
      }
    }
  },
  {
    type: 'text',
    formType: 'first_name',
    formLabel: 'firstName',
    editForm: {
      showOnRegFields: '1',
      required: '1',
      showOnEditProfile: '1',
      disabled: '1',
      onlyLetters: '1'
    }
  },
  {
    type: 'text',
    formType: 'last_name',
    formLabel: 'lastName',
    editForm: {
      showOnRegFields: '1',
      required: '1',
      showOnEditProfile: '1',
      disabled: '1',
      onlyLetters: '1'
    }
  },
  {
    type: 'date',
    formType: 'birthDate',
    name: 'birth_date',
    editForm: {
      disabled: '1',
      dateType: '1',
      label: 'Birth Date',
      ageLimit: '18',
      showOnRegFields: '0',
      showOnEditProfile: '1',
      required: '1'
    }
  },
  {
    type: 'email',
    formType: 'email',
    editForm: {
      showOnRegFields: '1',
      showOnEditProfile: '1',
      required: '1',
      disabled: '1'
    }
  },
  {
    type: 'password',
    formType: 'password',
    editForm: {
      showOnRegFields: '1'
    },
    params: {
      validations: {
        required: true
      }
    }
  },
  {
    type: 'password',
    confirm: true,
    formType: 'passwordConfirmation',
    name: 'password_confirmation',
    editForm: {
      showOnRegFields: '0'
    },
    params: {
      validations: {
        required: true
      }
    }
  },
  {
    type: 'select',
    formType: 'country',
    fromData: 'countries',
    name: 'country_code',
    editForm: {
      showOnRegFields: '1',
      required: '1',
      showOnEditProfile: '1',
      disabled: '1'
    }
  },
  {
    type: 'mobile-number',
    formType: 'mobileNumber',
    name: 'phone',
    editForm: {
      showOnRegFields: '0',
      showOnEditProfile: '1',
      required: '1',
      disabled: '1'
    }
  },
  {
    type: 'select',
    formType: 'currency',
    fromData: 'currencyList',
    inParams: true,
    name: 'currency_name',
    editForm: {
      showOnRegFields: '0',
      required: '1'
    }
  },
  {
    type: 'select',
    formType: 'occupation',
    fromData: 'occupations',
    name: 'occupation',
    editForm: {
      showOnRegFields: '0',
      showOnEditProfile: '1',
      required: '0'
    }
  },
  {
    type: 'text',
    formType: 'promoCode',
    name: 'promo_code',
    editForm: {
      showOnRegFields: '0',
      required: '0'
    }
  },
  {
    type: 'checkbox',
    formType: 'T&C_Checkbox',
    name: 'tccheckbox',
    editForm: {
      showOnRegFields: '1',
      required: '1'
    }
  },
  {
    type: 'zipCode',
    formType: 'zipCode',
    editForm: {
      showOnRegFields: '1',
      required: '1',
      showOnEditProfile: '1',
      disabled: '1'
    }
  }
] as TField[];
